var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpaceInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3841_70963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.90625 5.95825C6.90625 5.73389 6.72436 5.552 6.5 5.552C6.27564 5.552 6.09375 5.73389 6.09375 5.95825V9.20825C6.09375 9.43261 6.27564 9.6145 6.5 9.6145C6.72436 9.6145 6.90625 9.43261 6.90625 9.20825V5.95825Z",
    fill: "#131313",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.50004 0.677002C3.28413 0.677002 0.677124 3.28401 0.677124 6.49992C0.677124 9.71585 3.28413 12.3228 6.50004 12.3228C9.71597 12.3228 12.323 9.71585 12.323 6.49992C12.323 3.28401 9.71597 0.677002 6.50004 0.677002ZM1.48962 6.49992C1.48962 3.73274 3.73287 1.4895 6.50004 1.4895C9.2672 1.4895 11.5105 3.73274 11.5105 6.49992C11.5105 9.26708 9.2672 11.5103 6.50004 11.5103C3.73287 11.5103 1.48962 9.26708 1.48962 6.49992Z",
    fill: "#131313",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.04171 4.33317C7.04171 4.63232 6.7992 4.87484 6.50004 4.87484C6.20088 4.87484 5.95837 4.63232 5.95837 4.33317C5.95837 4.03402 6.20088 3.7915 6.50004 3.7915C6.7992 3.7915 7.04171 4.03402 7.04171 4.33317Z",
    fill: "#131313",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3841_70963"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceInfo);
export default __webpack_public_path__ + "static/media/spaceInfo.9229c51e366f35b783fa0c3ab980c705.svg";
export { ForwardRef as ReactComponent };